import { defaultMemoize } from 'reselect';
import _ from 'lodash';

import { DisplayWeekday } from '@tock/time';
import { IconArrowDownSmall } from 'ui/icons';
import { IconChevronSmallDown } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { getCoalescedRangesFromServices } from 'utils/businessUtils';
import DisplayHours from 'components/business/landing-page/DisplayHours';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

export interface OpenClose {
  openingTime: string;
  closingTime: string;
}

const getHours = defaultMemoize((services: core.Service[]) => {
  return [
    getCoalescedRangesFromServices(services, 'SUNDAY'),
    getCoalescedRangesFromServices(services, 'MONDAY'),
    getCoalescedRangesFromServices(services, 'TUESDAY'),
    getCoalescedRangesFromServices(services, 'WEDNESDAY'),
    getCoalescedRangesFromServices(services, 'THURSDAY'),
    getCoalescedRangesFromServices(services, 'FRIDAY'),
    getCoalescedRangesFromServices(services, 'SATURDAY'),
  ];
});

interface Props {
  services: core.IService[];
}

interface State {
  weekdayHours?: OpenClose[][];
  showHoursMenu: boolean;
}

export default class Hours extends PureBaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    const weekdayHours = getHours(props.services as core.Service[]);
    this.state = {
      showHoursMenu: false,
      weekdayHours,
    };
  }

  handleHoursMenuClick() {
    const { showHoursMenu } = this.state;
    this.setState({ showHoursMenu: !showHoursMenu });
  }

  render() {
    const { services } = this.props;
    const { weekdayHours, showHoursMenu } = this.state;
    const dayOfWeekTodayNumber = new Date().getDay();

    if (_.isEmpty(services) || !weekdayHours) {
      return null;
    }

    const allHoursMenu = (
      <div className="ProfileMetadata-hoursMenu">
        <Typography
          component="h4"
          className="ProfileMetadata-hoursMenuTitle"
          variant="body02Strong"
        >
          Hours
        </Typography>
        <ul>
          {_.map(weekdayHours, (dayTimes, index) => (
            <li
              key={index}
              className={`ProfileMetadata-hoursRow ${index === dayOfWeekTodayNumber && 'H1'}`}
            >
              <DisplayWeekday weekdayValue={index} displayWeekdayAs="long" />
              <DisplayHours times={dayTimes} />
            </li>
          ))}
        </ul>
      </div>
    );

    return (
      <div className="ProfileMetadata-hours">
        <button
          onClick={this.handleHoursMenuClick}
          aria-expanded={showHoursMenu}
          className="ProfileMetadata-hoursToday"
          data-testid="business-hour-today"
        >
          <Typography component="span" variant="body02">
            <DisplayHours todayLabel={true} times={weekdayHours[dayOfWeekTodayNumber]} />
          </Typography>

          <IconMigrationUtil
            legacyIcon={
              <IconArrowDownSmall
                className={`${showHoursMenu && 'is-open'} ProfileMetadata-hoursTriggerIcon`}
              />
            }
            newIcon={
              <IconChevronSmallDown
                className={`${showHoursMenu && 'is-open'} ProfileMetadata-hoursTriggerIcon`}
              />
            }
          />
        </button>
        {showHoursMenu && allHoursMenu}
      </div>
    );
  }
}
